import { getSettings } from './getSettings';
import { qstr } from './urls';

const settings = getSettings(['century', 'settings']);

const filterDefaults = {
  minPrice: settings.minPrice,
  maxPrice: settings.maxPrice,
  bedrooms: 1,
  bathrooms: 1,
  minSquareFeet: settings.minSquareFeet,
  maxSquareFeet: settings.maxSquareFeet,
  timeStamp: null,
  brand: settings.brand,
  homeTypes: '',
  bays: 0,
  floors: 0,
  quickMoveIn: false,
  mpcOnly: false,
  asc: true,
  sortBy: settings.defaultSortBy
};

const getFiltersFromSource = (source) => {
  return {
    minPrice: source.minPrice,
    maxPrice: source.maxPrice,
    bedrooms: source.bedrooms,
    bathrooms: source.bathrooms,
    minSquareFeet: source.minSquareFeet,
    maxSquareFeet: source.maxSquareFeet,
    brand: source.brand,
    homeTypes: source.homeTypes,
    bays: source.bays,
    floors: source.floors,
    mpcOnly: source.mpcOnly,
    asc: source.asc,
    sortBy: source.sortBy,
    timeStamp: new Date().getTime()
  };
};

const getFiltersForClear = (source, filters) => {
  const newFilters = getFiltersFromSource(source);
  filters.forEach((filter) => {
    if (filterDefaults[filter] !== undefined) {
      newFilters[filter] = filterDefaults[filter];
    } else {
      delete newFilters[filter];
    }
  });
  return newFilters;
};

const isValidHomeType = (ht) => {
  if (!ht) return false // if no home types in url query, return false
  const homeTypesArr = settings.homeTypes.split(',') // convert home types to array
  const homeTypesQueryArr = ht.split(',') // convert home types query string to array
  return homeTypesQueryArr.every(x => homeTypesArr.includes(x)) // return only home types that match the home types in the settings
};

const isValidBrand = nd => ['Century Communities','Century Complete'].filter(x => x === nd).length === 1;
const toBool = st => st === 'true' ? true : false;

const getFiltersFromQs = () => {
  return {
    minPrice: Number(qstr('np')) || filterDefaults.minPrice,
    maxPrice: Number(qstr('xp')) || filterDefaults.maxPrice,
    bedrooms: Number(qstr('br')) || filterDefaults.bedrooms,
    bathrooms: Number(qstr('ba')) || filterDefaults.bathrooms,
    minSquareFeet: Number(qstr('nf')) || filterDefaults.minSquareFeet,
    maxSquareFeet: Number(qstr('xf')) || filterDefaults.maxSquareFeet,
    timeStamp: null,
    brand: isValidBrand(qstr('nd')) ? qstr('nd') : filterDefaults.brand,
    homeTypes: isValidHomeType(qstr('ht')) ? qstr('ht') : filterDefaults.homeTypes,
    bays: Number(qstr('by')) || filterDefaults.bays,
    floors: Number(qstr('fl')) || filterDefaults.floors,
    quickMoveIn: toBool(qstr('qm')),
    mpcOnly: toBool(qstr('pc')),
    asc: Number(qstr('asc')) || filterDefaults.asc,
    sortBy: String(qstr('sb')) || filterDefaults.sortBy
  };
};

export { 
  filterDefaults,
  getFiltersFromSource,
  getFiltersForClear,
  getFiltersFromQs
};
